import styled, { css } from 'styled-components';
import { flex } from './Flex';

export const flexMiddle = css`
  ${flex};
  align-items: center;
`;

export const FlexMiddle = styled.div`
  ${flexMiddle};
`;
